export default __webpack_public_path__ + "static/media/turk.9c0266e9.svg";